import { apiSlice } from './apiSlice';

/**
 * Analyst agreements, one per funded account.
 *
 *   GET /v3/get/contract/user-list/ → { is_verified, data: [{ id, login_id,
 *                                       user_email, document_id, document_link,
 *                                       created_at, updated_at, issued, status,
 *                                       risk, challenge_name, is_verified }] }
 *
 * The top-level `is_verified` is true once every contract is signed; each row
 * carries its own. `status` is DigiSigner's ("In Progress", …).
 *
 *   GET /dg/get_siging_url/<id>/ → the DigiSigner page that contract is signed
 *                                  on (the path's spelling is the backend's)
 *
 * How a contract moves: the admin issues it (`issued`, "In Progress", no
 * `document_link` yet) → Sign contract asks for the signing URL and goes
 * there → closed unsigned, the row now carries `document_link`, and Sign
 * contract goes straight to it → once signed, the account is issued and the
 * contract leaves the list.
 */
export const contractsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContracts: builder.query({
      query: () => '/v3/get/contract/user-list/',
    }),

    // A mutation, not a query: each press wants a fresh link, never a cached one.
    getSigningUrl: builder.mutation({
      query: (id) => ({ url: `/dg/get_siging_url/${encodeURIComponent(id)}/`, method: 'GET' }),
    }),
  }),
});

export const { useGetContractsQuery, useGetSigningUrlMutation } = contractsApi;
